module.exports = __webpack_public_path__ + "img/selected2-min.aa37e9fb.png";